module.exports = __webpack_public_path__ + "static/img/preview-05.9e9859ef.webp";